import {
  ArrowLeftRight,
  ClipboardList,
  MapPin,
  Package,
  PackageCheck,
  PackageOpen,
  RotateCcw,
  ShoppingCart,
  TruckIcon,
} from "lucide-react";
import { Col, Divider, Row, Typography } from "antd";
import ActionCard from "../../Components/ActionCard";

const colorMap = {
  route: "#0b50da",
  purchase: "#1f9350",
  sales: "#ec5b13",
  transfer: "#9d26d9",
};

const { Title } = Typography;

const Dashboard = () => {
  const stockGroup = [
    {
      title: "Route Operations",
      color: "route",
      items: [
        {
          title: "Picking",
          description:
            "Selects route items from warehouse shelves for fulfillment.",
          icon: <MapPin />,
          path: "stocks/route-picking",
        },
        {
          title: "Packing",
          description:
            "Package picked items by route to prepare them for shipment.",
          icon: <PackageCheck />,
          path: "stocks/route-packing",
        },
        {
          title: "Returns",
          description: "Processes and reinstates returned route stock into inventory.",
          icon: <RotateCcw />,
          path: "stocks/route-returns",
        },
        {
          title: "Inventory Adjustments",
          description:
            "Applies stock adjustments to maintain accurate inventory records.",
          icon: <Package />,
          path: "stocks/inventory-adjustments",
        },
      ],
    },
    {
      title: "Sales Operations",
      color: "sales",
      items: [
        {
          title: "Dispatch",
          description: "Finalizes and releases packed orders for delivery.",
          icon: <TruckIcon />,
          path: "stocks/dispatch-stock",
        },
        {
          title: "Returns",
          description: "Inspect and reintegrate returned customer items.",
          icon: <PackageOpen />,
          path: 'stocks/receive-returned-stock',
        },
      ],
    },
    {
      title: "Purchase Orders",
      color: "purchase",
      items: [
        {
          title: "Receive Stock",
          description: "Record and verify received stock from suppliers.",
          icon: <ShoppingCart />,
          path: "stocks/receive-stock",
        },
        {
          title: "Add New Stock",
          description: "Registers and allocates new items to warehouse storage.",
          icon: <ClipboardList />,
          path: "stocks/new-stock",
        },
      ],
    },
    {
      title: "Stock Transfer",
      color: "transfer",
      items: [
        {
          title: "Transfer Stock",
          description:
            "Moves inventory between warehouse zones for reallocation.",
          icon: <ArrowLeftRight />,
          path: "stocks/transfer-stock",
        },
      ],
    },
  ];

  return stockGroup?.map((data, idx) => <GroupSection {...data} key={idx} />);
};

export default Dashboard;

const GroupSection = ({ title, color, items }) => {
  const sectionColor = colorMap[color];

  return (
    <div>
      <Title
        level={4}
        style={{
          marginBlock: 5,
          fontWeight: 600,
          color: sectionColor,
        }}
      >
        {title}
      </Title>
      <Row gutter={[16, 16]}>
        {items.map((item, idx) => (
          <Col key={idx} xs={24} sm={12} md={12} lg={6} xl={6}>
            <ActionCard {...item} color={sectionColor} />
          </Col>
        ))}
      </Row>
      <Divider style={{ margin: '20px 0 10px' }} />
    </div>
  );
};
